import { Toaster } from 'react-hot-toast';

export default function ToastContainer() {
  return (
    <Toaster
      position="top-right"
      containerStyle={{
        zIndex: 99999, // Ensure toasts appear above all modals
      }}
      toastOptions={{
        duration: 5000,
        style: {
          background: '#fff',
          color: '#333',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          padding: '16px',
          borderRadius: '8px',
          fontSize: '14px',
          zIndex: 99999, // Additional z-index for individual toasts
        },
        success: {
          iconTheme: {
            primary: '#10B981',
            secondary: '#fff',
          },
        },
        error: {
          iconTheme: {
            primary: '#EF4444',
            secondary: '#fff',
          },
        },
      }}
    />
  );
} 